import {PATHS} from '@freckle/educator-entities/ts/common/helpers/paths'
import {H4} from '@freckle/educator-materials/ts/components/typography'
import {useSafeTranslation} from '@freckle/educator-materials/ts/helpers/translate'
import {SafeTrans} from '@freckle/educator-materials/ts/helpers/translate/component'
import CleanUpRow from '@freckle/school/ts/rostering/components/common/clean-up-row'
import DetailColumn from '@freckle/school/ts/rostering/components/common/detail-column'

type Props = {
  isChecked: boolean
  onChange?: () => void
  numUnmanagedStudents: number
  activeIdpsString: string
}

export function MergeDuplicateStudents(props: Props) {
  const {isChecked, onChange, numUnmanagedStudents, activeIdpsString} = props
  const {t} = useSafeTranslation()

  return (
    <CleanUpRow
      src={`${PATHS.imageAssetsUrl}/school/icons/merge-duplicates.svg`}
      checkboxId="merge-duplicate-student-records"
      checkboxDataTest="merge-duplicate-student-records-checkbox"
      isChecked={isChecked}
      onChange={onChange}
      title={t('MERGE_DUPLICATE_STUDENTS_TITLE')}
      subTitle={t('MERGE_DUPLICATE_STUDENTS_SUBTITLE', {
        numUnmanagedStudents,
        activeIdpsString
      })}
      description={t('MERGE_DUPLICATE_STUDENTS_DESCRIPTION')}
    >
      <DetailColumn>
        <SafeTrans
          i18nKey="MERGE_DUPLICATE_STUDENTS_MERGE_CONDITONS"
          components={{ul: <ul />, li: <li />, h4: <H4 />}}
        />
      </DetailColumn>
      <DetailColumn>
        <SafeTrans
          i18nKey="MERGE_DUPLICATE_STUDENTS_AFTER_CLEAN_UP"
          components={{ul: <ul />, li: <li />, h4: <H4 />}}
        />
      </DetailColumn>
    </CleanUpRow>
  )
}
